import React from 'react';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import { getAsset } from '../../../../../../../util/assets';

const FreemiumEventTutorialMemoryBookStep = () => {
  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <p className="text-center">
          Let Waldo&rsquo;s friendly texting bot save you time gathering photos
          from friends and family and then automatically create beautiful slides
          for you!
        </p>
        <img
          src={getAsset('/memory-book-upsell-illustration.png')}
          alt=""
          width="365"
          className="mb-2 mx-auto d-flex"
        />
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

export default FreemiumEventTutorialMemoryBookStep;
